import siteTranslation from './siteLocalisation.json';

const LOCALES = {
  ENG: 'en',
  RUS: 'ru',
} as const;

type Locale = (typeof LOCALES)[keyof typeof LOCALES];

type Localisation = {
  [key in Locale]: Record<string, any>;
};

export { siteTranslation, LOCALES, Localisation, Locale };
